import { integrationConfig } from '@aibees/elephant/constants/integration';
import { useTableActionContext } from '@aibees/elephant/context';
import { useCheckUpgradeForIntegration } from '@aibees/elephant/hooks/integration/use-check-upgrade-for-integration';
import { ROUTES } from '@aibees/elephant/router';
import {
  IntegrationConfig,
  IntegrationStatus,
} from '@aibees/elephant/types/integration';
import { Chip } from '@aibees/shared/components';
import { useRouter } from '@aibees/shared/router';
import { classnames } from '@aibees/shared/utils';
import { useIsInternalUser } from '@aibees/shared/workspace/hooks/use-is-internal-user';
import { Box } from '@mui/material';
import { memo } from 'react';
import { useIntegrationPrepareDataBasedOnCount } from '../integration-tabs/use-integration-prepare-data-based-on-count';
import { QuickActionMenuItem } from '../quick-action-menu-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { QuickActionsButtonGroupIntegrationMenuProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'left',
} as const;

export const QuickActionsButtonGroupIntegrationMenu = memo(
  ({ className, state, anchorEl, handleClose }: Props) => {
    const { redirect } = useRouter();
    const internalUser = useIsInternalUser();
    const items = useIntegrationPrepareDataBasedOnCount(integrationConfig);
    const checkUpgradeForIntegration = useCheckUpgradeForIntegration();
    const { exportDialogState, setIntegrationConfig } = useTableActionContext();
    const nestedItems = items.filter(
      (x) => x.status !== IntegrationStatus.ComingSoon
    );

    const handleClickIntegrationItem = (item: IntegrationConfig) => {
      if (checkUpgradeForIntegration && !internalUser) {
        redirect(ROUTES.priceAndPlan);
      } else {
        exportDialogState.onTrue();
        handleClose?.();
        setIntegrationConfig(item);
      }
    };
    const handleCloseMainMenu = () => {
      state.onFalse();
      setIntegrationConfig(undefined);
    };
    return (
      <Styled.Wrapper
        className={classnames(
          'QuickActionsButtonGroupIntegrationMenu',
          className
        )}
        anchorEl={anchorEl}
        open={state.value}
        onClose={handleCloseMainMenu}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <Box sx={SX.root}>
          {nestedItems.map((item) => (
            <QuickActionMenuItem
              key={item.name}
              title={item.name!}
              avatar={item.icon}
              endIcon={
                checkUpgradeForIntegration &&
                !internalUser && (
                  <Chip
                    label="Upgrade"
                    color="warning"
                    size="xsmall"
                    shape="rounded"
                  />
                )
              }
              onClick={() => handleClickIntegrationItem(item)}
            />
          ))}
        </Box>
      </Styled.Wrapper>
    );
  }
);

QuickActionsButtonGroupIntegrationMenu.displayName =
  'QuickActionsButtonGroupIntegrationMenu';
